import { StyledPageLoadingDots } from './styles';

export const PageLoader = () => <StyledPageLoadingDots aria-label="The page is loading" />;
